module.exports = __webpack_public_path__ + "static/man.50a2445e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newLayout/assets/distributor/man.png
// module id = 809
// module chunks = 13643350389075